const createLeadModal = (el, campaign) => { 
	let modal = document.createElement('div');
	modal.classList.add('grow__modal', 'lead-modal');

	modal.innerHTML = `
		<div class="grow__modal-content">
			<div class="modal__header">
				<div onclick="closeLeadModal(this)" class="modal__close">&times;</div>
			</div>
			<div class="modal__body">
			<form onsubmit="checkLeadSubmission(this)" action="https://seu2.cleverreach.com/f/323946-382500/wcs/" target="_blank" method="post">
				<div>
					<label for="leademail">E-Mail*</label>
					<input type="email" id="leademail" name="email" value="" placeholder="name@example.com" required>
					<div class="input__columns">
						<div class="input__group">
							<label for="leadfirst">Vorname*</label>
							<input type="text" id="leadfirst" name="1126630" value="" placeholder="Vorname" required>
						</div>
						<div class="input__group">
							<label for="leadlast">Nachname*</label>
							<input type="text" id="leadlast" name="1126631" value="" placeholder="Nachname" required>
						</div>
					</div>
					<label for="leadcomp">Firma*</label>
					<input type="text" id="leadcomp" name="1130235" value="" placeholder="Firma" required>
					<input type="hidden" name="1124557" value="${campaign}">  
					<input type="hidden" name="action" value="https://seu2.cleverreach.com/f/323946-382500/wcs/">  
					<input type="hidden" name="return" value="${window.location.href}">  
				</div>       
				<div class="checkbox__container">
					<input type="checkbox" id="modalconsent" name="consent" value="Consent" required="">
					<label for="modalconsent" >
						Die GROW Digital Group darf meine Angaben speichern und zur Beantwortung meiner Anfrage verwenden. Weitere Infos: <a href="/datenschutz" target="_blank">Datenschutzerklärung.</a>*
					</label>
				</div>
				<div class="checkbox__container">
					<input type="checkbox" id="modalnewsletter" name="newsletter" value="Newsletter" required="">
					<label for="modalnewsletter" >
						Ja, informiert mich über interessante Neuigkeiten und Events von GROW.*
					</label>
				</div>
				<button type="submit" class="main__button">Jetzt herunterladen</button>      
			</form>
			</div>
		</div>
	`;	
	document.body.appendChild(modal);
}

const checkLeadSubmission = (el) => { 
	let email = el.querySelector('#leademail').value;
	let first = el.querySelector('#leadfirst').value;
	let last = el.querySelector('#leadlast').value;
	let comp = el.querySelector('#leadcomp').value;
	let consent = el.querySelector('#modalconsent').checked;
	let newsletter = el.querySelector('#modalnewsletter').checked;
	
	if (email && first && last && comp && consent && newsletter) {
		el.submit();
		setTimeout(() => {
			closeLeadModal();
		}, 2000);
	}
	else {
		alert('Bitte füllen Sie alle Pflichtfelder aus.');
		return false;
	}
}

const closeLeadModal = (el) => { 
	if (el) {
		el.closest('.grow__modal').remove();
	}
	else if (document.querySelector('.grow__modal')) {
		document.querySelector('.grow__modal').remove();
	}
	else {
		return
	}
}

window.addEventListener('keyup', (e) => {
	if (e.key === 'Escape') closeLeadModal();
});

